type RequestDataType = {
  request: string;
  policyKey: string;
};

type SentRequestPropType = {
  requestData: RequestDataType;
  callback: (videoData: string) => void;
};

export default (videoIds: string[]): void => {
  const accountId = process.env.REACT_APP_BRIGHTCOVE_ID || '';
  const policyKey = process.env.REACT_APP_BRIGHTCOVE_POLICY_KEY || '';

  function addPosters(data: { id: string; poster: string }[]) {
    data.forEach(item => {
      const videoPoster = document.getElementById(`img-${item.id}`);
      if (videoPoster) {
        videoPoster.setAttribute('src', item.poster);
      }
    });
  }

  function createRequest() {
    const requestData: RequestDataType = {
      request: `https://edge.api.brightcove.com/playback/v1/accounts/${accountId}/videos?q=`,
      policyKey,
    };

    // add video ids to the search string
    for (let i = 0; i < videoIds.length; i++) {
      requestData.request = `${requestData.request}id:${videoIds[i]}`;
      if (i < videoIds.length - 1) {
        requestData.request += '%20';
      }
    }
    requestData.request = `${requestData.request}&limit=1000`;

    const callback = (videoData: string) => {
      if (videoData && videoData.length > 0) {
        const data = JSON.parse(videoData);
        addPosters(data.videos);
      }
    };

    // add the policy key
    sendRequest({ requestData, callback });
  }

  function sendRequest({ requestData, callback }: SentRequestPropType) {
    const httpRequest = new XMLHttpRequest();
    // response handler
    const getResponse = (): void => {
      try {
        if (httpRequest.readyState === 4) {
          if (httpRequest.status >= 200 && httpRequest.status < 300) {
            callback(httpRequest.responseText);
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-alert
        alert(`Caught Exception: ${e}`);
      }
    };

    // set response handler
    httpRequest.onreadystatechange = getResponse;
    // open the request
    httpRequest.open('GET', requestData.request);
    // set headers
    httpRequest.setRequestHeader('BCOV-Policy', requestData.policyKey);
    // open and send request
    httpRequest.send();
  }

  // kick things off by fetching the video data
  createRequest();
};
